export default "__VITE_ASSET__7u6iWo1q__"